/**
 * Phase 93 (Plan 93-01, Task 1) — TanStack Query wrapper for `GET /api/modules`.
 *
 * `staleTime: Infinity` is deliberate: `ENABLED_MODULES` only changes at
 * redeploy (`backend/src/config/modules.ts`'s memoized `getEnabledModules()`),
 * so there is no runtime mutation path within a session — a hard page reload
 * is the only way the set can ever change, and that naturally re-fetches on
 * next mount. Do not add `refetchInterval`.
 */
import { useQuery } from '@tanstack/react-query';
import { getModules } from '../services/api/modules';

export function useEnabledModules(enabled: boolean) {
  return useQuery({
    queryKey: ['modules'],
    queryFn: getModules,
    enabled,
    staleTime: Infinity,
  });
}
